<template>
  <div
    id="quizQuestionPage"
    v-if="quiz != null"
    :class="'popupPage anim' + (open ? ' open' : '')"
  >
    <div
      v-if="page == 'question' && question != null && open"
      class="questionPage container h-100"
    >
      <div class="row h-100">
        <div class="col-md-6 h-100 m-auto d-flex flex-column">
          <div class="header mb-3">
            <div v-if="activeUsers != ''" class="activeUsers">
              <i class="fas fa-users"></i>
              <h4>
                <b>{{ activeUsers }}</b>
              </h4>
            </div>
            <progress-bar
              type="circle"
              :text="questionTimerText"
              ref="circle"
              :options="progressOptions"
              class="timer animate__animated animate__zoomIn animate__faster"
            ></progress-bar>
            <a
              @click.prevent="
                hide();
                btnSfx();
              "
              href="#"
              class="close"
            ></a>
          </div>

          <div
            v-if="question.question.imageUrl != undefined"
            class="questionWithImage mb-3 w-100"
          >
            <div
              class="w-100 vh-20 mb-3 d-flex justify-content-center align-items-center"
            >
              <img :src="question.question.imageUrl" class="m-auto" />
            </div>
            <h5 class="d-flex align-items-center mb-0">
              {{ question.question.text }}
            </h5>
          </div>
          <h3 v-else class="d-flex align-items-center vh-20">
            {{ question.question.text }}
          </h3>

          <ul class="answers">
            <li
              @click="
                selectAnswer(a);
                btnSfx();
              "
              v-for="a in question.question.answers"
              :key="a.id"
              :class="
                selectedId == a.id
                  ? selectedState
                  : correctAnswer != null && correctAnswer.id == a.id
                  ? 'correct'
                  : ''
              "
            >
              <span v-if="stats != null"
                >{{
                  stats[a.id] != undefined ? Math.round(stats[a.id]) : 0
                }}%</span
              >
              {{ a.text }}
              <i class="fas fa-check-circle"></i
              ><i class="fas fa-times-circle"></i>
            </li>
          </ul>
          <div class="questionStep">
            <ul class="p-0 mb-3">
              <li
                v-for="n in quiz.questionCount"
                :key="n"
                :class="question.ordinal >= n ? 'on' : ''"
              ></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="page == 'resultsPage'" class="resultsPage container h-100">
      <div class="row h-100">
        <div class="col-md-6 h-100 m-auto d-flex flex-column text-center">
          <div class="header mb-3">
            <div v-if="activeUsers != ''" class="activeUsers">
              <i class="fas fa-users"></i>
              <h4>
                <b>{{ activeUsers }}</b>
              </h4>
            </div>
            <progress-bar
              type="circle"
              :text="questionTimerText"
              ref="circle"
              :options="progressOptions"
              class="timer animate__animated animate__zoomIn animate__faster"
            ></progress-bar>
            <a
              @click.prevent="
                hide();
                btnSfx();
              "
              href="#"
              class="close"
            ></a>
          </div>
          <div class="mt-auto mb-auto ml-md-4 mr-md-4">
            <div class="bear-results mt-4 p-4 p-lg-5 d-flex">
              <img
                v-if="selectedState == 'correct'"
                :src="
                  '/images/theme/' +
                  (user.mtsCustomer ? 'mts' : 'default') +
                  '/bear/bear-question-ok.png'
                "
                class="animate__animated animate__fadeInLeft"
              />
              <img
                v-else
                :src="
                  '/images/theme/' +
                  (user.mtsCustomer ? 'mts' : 'default') +
                  '/bear/bear-question-sad.png'
                "
                class="animate__animated animate__fadeInLeft animate__faster"
              />
              <p
                v-if="selectedState == 'correct'"
                class="animate__animated animate__bounceIn animate__faster animate__delay-1s"
              >
                {{ $t("trivia.quiz_question_correct_title") }}
              </p>
              <p
                v-else
                class="animate__animated animate__bounceIn animate__faster animate__delay-1s"
              >
                {{ $t("trivia.quiz_question_incorrect_title") }}
              </p>
            </div>

            <p v-if="selectedState == 'correct'" class="text-primary">
              {{ $t("trivia.quiz_question_correct_subtitle") }}
            </p>
            <p v-else-if="selectedState == 'wrong'" class="text-primary">
              {{ $t("trivia.quiz_question_incorrect_subtitle") }}
            </p>
            <p v-else class="text-primary">
              {{ $t("trivia.quiz_question_timeout_subtitle") }}
            </p>

            <div
              v-if="selectedState != 'correct'"
              class="actionHolder p-3 w-100"
            >
              <div v-if="jokerUsed">
                <h3
                  class="text-orange"
                  v-html="$t('trivia.quiz_question_incorrect_jocker_active')"
                ></h3>
              </div>
              <div v-else-if="!confirmFollow && jokerPossible">
                <div class="text-orange mb-2">
                  {{ $t("trivia.quiz_question_incorrect_jocker_desc") }}
                </div>
                <b-button
                  @click="
                    useJoker();
                    btnSfx();
                  "
                  variant="primary"
                  size="lg"
                  class="mb-3 pt-2"
                  ><img src="/images/joker.png" style="height: 1.5em" />&nbsp;
                  {{
                    $t("trivia.quiz_question_incorrect_jocker_btn")
                  }}</b-button
                >
              </div>

              <div
                v-if="
                  question != null && quiz.questionCount == question.ordinal
                "
              >
                <h3 v-html="$t('trivia.quiz_question_incorrect_end_info')"></h3>
              </div>
              <div v-else-if="!jokerUsed && !confirmFollow">
                <b-button
                  @click="
                    setFollow();
                    btnSfx();
                  "
                  variant="success"
                  size="lg"
                  class="mb-3 pt-2"
                  >{{ $t("trivia.quiz_question_incorrect_btn") }}</b-button
                >
              </div>
              <div v-else-if="confirmFollow">
                <h3
                  v-html="$t('trivia.quiz_question_incorrect_follow_info')"
                ></h3>
              </div>
            </div>
          </div>
          <div class="questionStep">
            <ul class="p-0 mb-3">
              <li
                v-for="n in quiz.questionCount"
                :key="n"
                :class="question.ordinal >= n ? 'on' : ''"
              ></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="page == 'rankPage'" class="rankPage h-100">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-md-6 h-100 m-auto d-flex flex-column">
            <div class="header mb-3">
              <h3 class="m-auto">{{ $t("trivia.quiz_result_title") }}</h3>
              <a
                @click.prevent="
                  hide();
                  btnSfx();
                "
                href="#"
                class="close"
              ></a>
            </div>

            <div v-if="isWinner" class="resultsPageHeader winner">
              <img
                :src="
                  user.avatarUrl != undefined
                    ? user.avatarUrl
                    : '/images/male-default.png'
                "
                class="avatar"
              />
              <h4 class="text-orange mb-0">
                {{ $t("trivia.quiz_result_win_title") }}
              </h4>
              <span class="text-primary">{{
                $t("trivia.quiz_result_win_subtitle")
              }}</span>
              <div class="award">
                <div>{{ $t("trivia.quiz_result_win_award_title") }}</div>
                <h3>{{ award.toLocaleString("sr-RS") }}</h3>
              </div>
              <h5 class="text-primary">
                {{ $t("trivia.quiz_result_win_other_users") }}
              </h5>
            </div>
            <div v-else class="resultsPageHeader">
              <img class="m-auto vh-10" src="/images/shop/diamonds/6.png" />
              <h4 class="mb-3 text-orange">
                {{ $t("trivia.quiz_result_info_title") }}
              </h4>
            </div>

            <ul :class="'winnersList' + (isWinner ? ' winner' : '')">
              <li
                v-for="w in winners.filter((d) => d.user.id != user.id)"
                :key="w.user.id"
              >
                <img
                  :src="
                    w.user.avatarUrl != undefined
                      ? w.user.avatarUrl
                      : '/images/male-default.png'
                  "
                />
                <h5 class="mb-0">{{ w.user.username }}</h5>
                <span
                  ><img src="/images/diamond.png" />
                  <b>{{ w.award.toLocaleString("sr-RS") }}</b></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="page == 'interludePage' && interlude != null"
      class="interludePage h-100"
    >
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-md-6 h-100 m-auto d-flex flex-column">
            <h3
              class="m-auto text-center text-primary animate__animated animate__backInRight"
              v-html="interlude"
            ></h3>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="page == 'introPage' && intro != null"
      class="introPage h-100"
    >
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-md-6 h-100 m-auto d-flex flex-column">
            <h1
              class="m-auto text-center animate__animated animate__fadeIn"
              v-html="intro"
            ></h1>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="page == 'outroPage' && outro != null"
      class="outroPage h-100"
    >
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-md-6 h-100 ml-auto mr-auto d-flex flex-column">
            <div
              class="bearOutroBox text-center animate__animated animate__fadeInUp animate__faster"
            >
              <span></span>
              <p v-html="outro"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import api from "../api";
import confetti from "../confettiHelpers";

const TriviaQuizQuestion = Vue.component("trivia-quiz-question", {
  data() {
    return {
      open: false,
      play: true,
      confirmFollow: false,
      page: "question",
      question: null,
      correctAnswer: null,

      canSelectAnswer: true,
      selectedId: null,
      selectedState: "",
      questionTimerText: 0,
      activeUsers: "",
      jokerPossible: false,
      jokerApplicationDeadline: "",
      jokerUsed: false,

      interlude: null,
      intro: "",
      outro: "",
      stats: null,

      isWinner: false,
      award: 0,
      winners: [],
      winnersPage: 1,
      winnersLoadingPage: false,
      allLoaded: false,

      progressOptions: {
        color: "#ff8500",
        trailColor: "#abccee",
        strokeWidth: 14,
        trailWidth: 14,
        from: { color: "#ff4e36" },
        to: { color: "#ff8500" },
        step: function (state, circle, attachment) {
          circle.path.setAttribute("stroke", state.color);
        },
      },
    };
  },
  questionTimer: null,
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    quiz() {
      return this.$store.state.trivia.quiz;
    },
    follow() {
      return this.$store.state.trivia.follow;
    },
    networkTimeDiff() {
      return this.$store.state.config.networkTimeDiff;
    },
  },
  methods: {
    btnSfx() {
      this.$store.dispatch("sound/sfx", "Button");
    },

    replaceTags(str) {
      str = str.replace(
        /<link="(.*?)"  >(.*?)<\/link>/g,
        '<a target="_blank" href="$1">$2</a>'
      );
      str = str.replace(
        /<color="(.*?)">(.*?)<\/color>/g,
        '<span style="color:$1;">$2</color>'
      );
      str = str.replace(/\\u2022/g, "&#x2022 ");
      str = str.replace(/(?:\r\n|\r|\n)/g, "<br>");
      return str;
    },

    setIntro: function (data) {
      this.open = true;
      this.intro = this.replaceTags(data.intro);
      this.page = "introPage";
    },

    setOutro: function (data) {
      this.open = true;
      this.outro = this.replaceTags(data.outro);
      this.page = "outroPage";
    },

    setInterlude: function (data) {
      this.open = true;
      this.interlude = this.replaceTags(data.text);
      this.page = "interludePage";
    },

    setEnd: function () {
      const $this = this;
      this.winnersAllLoaded = false;
      this.getWinners(1);
    },

    getWinners: function (page) {
      const $this = this;
      if (this.winnersAllLoaded || this.winnersLoadingPage) return;

      if (page == undefined) {
        page = this.winnersPage + 1;
      }

      this.winnersLoadingPage = true;
      api
        .triviaQuizWinners(page)
        .then((response) => {
          $this.winnersPage = page;
          $this.winners = $this.winners.concat(response.data);

          if (response.data.length == 0) $this.winnersAllLoaded = true;

          if (page == 1) {
            if (response.data.length == 0) {
              $this.$bvModal
                .msgBoxOk($this.$t("trivia.quiz_no_results_text"), {
                  title: $this.$t("trivia.quiz_no_results_title"),
                  size: "sm",
                  buttonSize: "lg",
                  okTitle: $this.$t("base.btn_ok"),
                  modalClass: "confirmModal",
                  hideHeaderClose: false,
                  centered: true,
                })
                .then((value) => {
                  $this.$store.dispatch("sound/sfx", "Button");
                });
              $this.hide();
            } else {
              $this.page = "rankPage";
              $this.$store.dispatch("sound/sfx", "Achievements");
              setTimeout(function () {
                const listElm = document.querySelector(".winnersList");
                listElm.addEventListener("scroll", (e) => {
                  let bottom =
                    Math.abs(
                      listElm.scrollHeight -
                        (listElm.scrollTop + listElm.clientHeight)
                    ) < 1;
                  if (bottom) {
                    $this.getWinners();
                  }
                });
              }, 200);
            }

            $this.isWinner =
              response.data.length > 0 &&
              response.data[0].user.id == $this.user.id;
            if ($this.isWinner) {
              $this.award = response.data[0].award;
              $this.$store.dispatch("auth/getMe");
            }
          }
        })
        .catch((error) => {
          api.baseErrorHendler(error);
          $this.hide();
        })
        .then((r) => {
          $this.winnersLoadingPage = false;
        });
    },

    setQuestion(question) {
      const $this = this;
      this.open = true;
      this.page = "question";
      this.winners = [];
      this.question = question;
      this.correctAnswer = false;
      this.selectedId = null;
      this.selectedState = "";
      this.canSelectAnswer = true;
      this.jokerPossible = false;
      this.jokerUsed = false;
      this.winnersLoadingPage = false;
      this.stats = null;
      this.activeUsers =
        question.reach > 0
          ? question.reach.ToString()
          : question.approximateReach != ""
          ? question.approximateReach
          : "";
      this.$store.dispatch("sound/bg", "BG_TriviaQuiz");
      setTimeout(function () {
        $this.setTimer();
      }, 150);
    },

    setTimer() {
      const $this = this;

      let netTime = moment.utc() + this.networkTimeDiff;
      let durationSec = moment
        .duration(moment.utc(this.question.deadline).diff(moment.utc(netTime)))
        .seconds();
      let current = durationSec;
      // console.log(moment.utc(netTime).format(), moment.utc(this.question.deadline), durationSec);

      if (this.questionTimer != null) {
        clearInterval(this.questionTimer);
        this.questionTimer = null;
      }

      if (current <= 0) {
        this.$refs.circle.setText(0);
        this.$refs.circle.set(0);
        this.canSelectAnswer = false;
        return;
      }

      this.$refs.circle.setText(current);
      this.questionTimer = setInterval(() => {
        current -= 1; // count down (-1000 ms)
        if (current <= 5 && this.play && this.selectedId == null)
          this.$store.dispatch("sound/sfx", "Timer");
        if (current >= 0) {
          this.$refs.circle.animate(current / durationSec);
          this.$refs.circle.setText(current);
        }
        if (current <= 0) {
          this.canSelectAnswer = false;
          clearInterval(this.questionTimer);
          this.questionTimer = null;
        }
      }, 1000);

      this.$refs.circle.set(1);
    },

    setJokerTimer() {
      if (this.jokerTimer != null) {
        clearInterval(this.jokerTimer);
        this.jokerTimer = null;
      }

      if (!this.jokerPossible) return;

      let netTime = moment.utc() + this.networkTimeDiff;
      let current = moment
        .duration(
          moment.utc(this.jokerApplicationDeadline).diff(moment.utc(netTime))
        )
        .seconds();

      this.jokerTimer = setInterval(() => {
        current -= 1; // count down (-1000 ms)
        if (current < 0) {
          this.jokerPossible = false;
          clearInterval(this.jokerTimer);
          this.jokerTimer = null;
        }
      }, 1000);
    },

    hide() {
      this.open = false;
      this.question = null;
      this.confirmFollow = false;
      this.play = true;
      this.$store.dispatch("trivia/setFollow", false);
      this.$store.dispatch("trivia/getQuiz");
    },

    async selectAnswer(answer) {
      if (!this.canSelectAnswer || this.selectedId != null || !this.play)
        return;

      this.selectedState = "marked";
      this.selectedId = answer.id;
      this.canSelectAnswer = false;

      let loader = document.getElementById("loader");
      loader.classList.add("show");

      try {
        let response = await api.triviaQuizAnswer(
          this.quiz.id,
          this.question.question.id,
          answer.id
        );
        this.jokerPossible = response.data.jokerPossible;
        this.jokerApplicationDeadline = response.data.jokerApplicationDeadline;
        this.selectedState = "selected";
        this.setJokerTimer();
      } catch (error) {
        api.baseErrorHendler(error);
        this.selectedState = "";
        this.selectedId = null;
        this.canSelectAnswer = true;
      }

      loader.classList.remove("show");
    },

    setAnswer(answer) {
      const $this = this;

      this.correctAnswer = answer;
      if (answer.id == this.selectedId) {
        this.selectedState = "correct";
      } else if (this.selectedId != null) {
        this.selectedState = "wrong";
      } else this.selectedState = "";

      if (this.play) {
        // timeout check can use joker
        if (this.selectedState == "") this.getFlow();

        setTimeout(function () {
          if ($this.selectedState != "correct") $this.play = false;
          if ($this.page != "rankPage") {
            $this.page = "resultsPage";
          }

          if ($this.selectedState == "correct") {
            confetti.bgHappy(6);
            $this.$store.dispatch("sound/sfx", "Achievements");
          } else {
            $this.$store.dispatch("sound/sfx", "Fail");
          }
        }, 2000);
      }
    },

    setAnswerStats(data) {
      this.stats = data;
    },

    async useJoker() {
      if (!this.jokerPossible) return;

      let loader = document.getElementById("loader");
      loader.classList.add("show");

      try {
        let response = await api.triviaQuizAnswerJoker(
          this.quiz.id,
          this.question.question.id
        );
        this.play = true;
        this.jokerPossible = false;
        this.jokerUsed = true;
        this.$store.dispatch("auth/getMe");
      } catch (error) {
        api.baseErrorHendler(error);
      }

      loader.classList.remove("show");
    },

    async getFlow() {
      let loader = document.getElementById("loader");
      loader.classList.add("show");

      try {
        let response = await api.triviaQuizFlow(
          this.quiz.id,
          this.question.question.id
        );
        this.jokerPossible = response.data.jokerPossible;
        this.jokerApplicationDeadline = response.data.jokerApplicationDeadline;
        this.jokerUsed = false;
        this.setJokerTimer();
      } catch (error) {
        api.baseErrorHendler(error);
      }

      loader.classList.remove("show");
    },

    setFollow() {
      this.confirmFollow = true;
      this.$store.dispatch("trivia/setFollow", true);
    },
  },

  watch: {
    open() {
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      document.body.scrollTop = 0; // For Safari
      if (this.open) document.body.classList.add("lock");
      else document.body.classList.remove("lock");
    },
  },
});

export default TriviaQuizQuestion;
</script>